import React from 'react'
import { OverlayTrigger,Tooltip } from 'react-bootstrap'
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType'
import { DisbursementsListType } from '../../../redux/disbursements/disbursementsType'
import { formateDateWithTime,formatDate} from '../../../utils/commonFunctions'
import Avatar from '../../commons/CircularAvatar/CircularAvatar'
import { PaperClipIcon } from '../../Icon'
import { tableEditIcon } from '../../../assets/images'
type AppProps = {
  disbursementModuleList:[]|DisbursementsListType[]
  tableHeader: [] | TableHeadersType[];
  handleEditDisbursementData:(id:number)=>void
  isEditDisbursementPresent?:boolean;
}
const DisbursementTableData = ({
  disbursementModuleList,
  tableHeader,
  handleEditDisbursementData,
  isEditDisbursementPresent
}: AppProps) => {

  return (
    <>{
      disbursementModuleList && disbursementModuleList?.length > 0 && disbursementModuleList?.map((dataItem: any) => {
        return <tr>
          {tableHeader && tableHeader?.length > 0 && tableHeader?.map((item: any) => {
            if (item?.value === 'attachments') {
              return dataItem?.attachment?.length ?
                <td className='position-relative'>
                  <PaperClipIcon />
                  <span className="badge count-badge">{dataItem?.attachment?.length}</span></td> : <td> --/-- </td>
            }
            else if(item?.value==="client_name"){
              return<td className='text-center' style={{ minWidth: '130px'}}>{`${dataItem?.client_name} (${dataItem?.client_code})`}
              </td>
            }
            else if(item?.value==="job_type"){
              return<td className='text-center' style={{ minWidth: '120px'}}>{dataItem?.job_type}<br/>
              <label>{dataItem?.client_job_id}</label>
              </td>
            }
            else if(item?.value==="payment_status"){
              return<td style={{ minWidth: '140px', textAlign: 'center' }}> 
              <span className='ml-2'>
                   {dataItem?.payment_status === 'paid' && <span className="credit">Paid</span> 
                     }
                   {dataItem?.payment_status === 'pending' && <span className="debit">Pending</span> 
                     }
                   {dataItem?.payment_status === "partial paid" && <span className="status-incomplete">Partial Paid</span> 
                     }
                 </span>
             </td>
            }
            else if(item?.value==="payment_date"){
              return<td style={{ minWidth: '130px', textAlign: 'center' }}> 
              {dataItem?.payment_date?formatDate(dataItem?.payment_date):"--/--"}
             </td>
            }
            else if (item.value === 'approved_by') {
              return <td style={{ textAlign: 'center' }}>
                <div className="d-flex">
                  {dataItem?.approval_details?.length>0 ? dataItem?.approval_details?.map((profileData: any) => {
                  
                    let fullName = profileData?.user_name;
              
                    return <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                         overlay={ <Tooltip id="button-view-open-item">
                          {fullName}<br></br>
                      approved on {formateDateWithTime(profileData?.approved_at)}
                        </Tooltip>}>
                      <span style={{cursor:"pointer",marginLeft:'3px'}}>
                         <Avatar name={fullName}
                        image={profileData?.profile_pic?.file_url}
                        />
                        </span>
                    </OverlayTrigger>
                }):<span>--/--</span>}
                </div>
              </td>
            }
            else if(item?.value==="created_at"){
              return<td className='text-center'>{dataItem?.created_by}<br/>
              <span className='due-date-text'>{formateDateWithTime(dataItem?.created_at)}</span>
              </td>
            }
            else if(item?.value==="updated_at"){
              return<td className='text-center'>{dataItem?.updated_by}<br/>
              <span className='due-date-text'>{formateDateWithTime(dataItem?.updated_at)}</span>
              </td>
            }
            else if (
              item.value == 'edit') {
              return <td style={{ minWidth: '70px', textAlign: 'center' }}>
                {isEditDisbursementPresent &&
                <span className="d-inline-block pointer"
                  onClick={() => handleEditDisbursementData?.(dataItem?.disbursement_id)}
                >
                  <div style={{
                    color: '#d43',
                    fontSize: 20,
                  }}>
                  <img src={tableEditIcon}alt ="edit"/>
                  </div>
                </span>
                 }
              </td>
            }
            return <td className='text-center'>{dataItem[item.value]}</td>
          })}
        </tr>
      })
    }
    </>
  )
}

export default DisbursementTableData